import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop'
import { map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SchedulerStepService } from '../step/scheduler-step.service';
import { FormatPipe } from '@app/pipes/format.pipe';
import { CalendarAvailabilityService } from '../calendarAvailability/calendarAvailability.service';
import { CategoriesService } from '../categories/categories.service';
import { EventDispatcher } from '@angular/core/primitives/event-dispatch';
import { setErrorMessage } from 'src/utils';

@Injectable({
  providedIn: 'root'
})
export class CancelAppointment {

  private apiURL: string = environment.apiURL
  private cancelEndpoint: string = environment.cancelEndPoint
  private http = inject(HttpClient)
  
  private formatPipe = inject(FormatPipe)

  eventID= signal<Number>(-1)

  cancelResource = rxResource({ 
    request: () => ({
      eventID : this.eventID()
    }),
    loader: ( {request} ) => {
      if(this.eventID() === -1) return of (null)
      return this.http.patch<AvailabilitiesType[]>(`${this.apiURL}${this.formatPipe.transform(this.cancelEndpoint, {'eventID': request.eventID})}`, {})
    .pipe(
      map(cancelResponse => cancelResponse )
    )}
  })

  error = computed(() => this.cancelResource.error() as HttpErrorResponse);
  errorMessage = computed(() => setErrorMessage(this.error(), 'Invaders'));
}
